import { ref } from "vue-demi";
import { debounce } from "lodash-es";
import { getList, postTransferQueryParam } from "../request/bsplatform/external/commodity/transferQueryParam/post.js";
const resultMap = new Map();
const resultPromiseMap = new Map();
const resolveMap = new Map();
const requestParams = [];
const classificationTemplateMap = ref({});
const axiosGetShowConfigButton = async () => {
  var _a, _b;
  const ret = await getList({});
  if (ret.data && ret.data.length > 0) {
    const list = {};
    ret.data.forEach(({ id, templateCode }) => {
      if (id && templateCode) {
        const rowId = templateCode.slice(templateCode.indexOf("_") + 1);
        list[id] = rowId;
      }
    });
    classificationTemplateMap.value = list;
  }
  const params = [...requestParams];
  requestParams.length = 0;
  const inventory = params.map((item) => {
    return {
      commodityId: item.commodityId,
      paramConfig: item.paramConfig,
      quantity: item.quantity
    };
  });
  const res = await postTransferQueryParam({ inventory, productType: "STANDARD" });
  const showConfigButtons = ((_b = (_a = res.data) == null ? void 0 : _a.inventory) == null ? void 0 : _b.map((item) => item)) || [];
  params.forEach((param, index) => {
    const resolve = resolveMap.get(param);
    if (resolve) {
      const resolvedValue = showConfigButtons[index] || [];
      let isShowConfigButton = false;
      if (resolvedValue.paramConfig && resolvedValue.paramConfig.details && resolvedValue.paramConfig.details.classificationId in classificationTemplateMap.value) {
        isShowConfigButton = true;
      } else if (resolvedValue.showConfigButton && resolvedValue.editableAttributeColumn && resolvedValue.editableAttributeColumn.length > 0) {
        isShowConfigButton = true;
      }
      resolve(isShowConfigButton);
      resolveMap.delete(param);
    }
    resultPromiseMap.delete(param);
    const result = resultMap.get(param);
    if (result) {
      if (!result.value) {
        const storedValue = showConfigButtons[index] || [];
        result.value = storedValue;
      }
    } else {
      const storedValue = showConfigButtons[index] || [];
      resultMap.set(param, ref(storedValue));
    }
  });
};
const debounceGetShowConfigButton = debounce(axiosGetShowConfigButton, 600);
async function getShowConfigButtonAsync(commodityId, paramConfig, quantity) {
  const obj = {
    commodityId,
    paramConfig,
    quantity
  };
  const result = resultMap.get(obj);
  if (result == null ? void 0 : result.value) {
    return result.value;
  }
  const resultPromise = resultPromiseMap.get(obj);
  if (resultPromise) {
    try {
      const res = await resultPromise;
      return res;
    } catch (error) {
      console.error("\u7B49\u5F85\u73B0\u6709\u8BF7\u6C42\u65F6\u51FA\u9519:", error);
      return false;
    }
  }
  let resolveFunction = null;
  const promise = new Promise((resolve) => {
    resolveFunction = resolve;
  });
  if (resolveFunction) {
    resolveMap.set(obj, resolveFunction);
  }
  resultPromiseMap.set(obj, promise);
  requestParams.push(obj);
  debounceGetShowConfigButton();
  try {
    const res = await promise;
    return res;
  } catch (error) {
    return false;
  }
}
export { getShowConfigButtonAsync };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/utils/getShowConfigButton.js